import { DataBean } from "../../DataBean";


export class HealthEntity extends DataBean {

    public async getHealthEntityCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthEntityCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}